import Header from "./moduleComponents/Header";
// import Banner from './moduleComponents/Banner';
import Banners from "./moduleComponents/banners";
import Weather from "./moduleComponents/weather";
import Service from "./moduleComponents/Service";
import Enterprises from "./moduleComponents/Enterprises";
import Cards from "./moduleComponents/Cards";
import FeedTab from "./moduleComponents/FeedTab";
import Grows from "./moduleComponents/Grows";
export const LAYOUT_MODULE_MAP: any = {
  100000: Header, // 头部导航
  100001: Banners, // banner
  100002: Service, // 常用服务
  100003: Weather, // 今日热点
  100004: Cards, // 运营瓷片
  100005: Enterprises, // 企业服务
  100006: Grows, // 成长计划
  100007: FeedTab // feed流
};
